import CommonIcon from "../CommonIcon";
import sanitizeHtml from 'sanitize-html';
// import { useRouter } from "next/router";
import styles from './index.module.scss';
import FeedPreview from "../FeedPreview";
import { PromiseState } from '@/constants';
import { useTranslations } from "next-intl";
import { FC, useMemo, useContext } from "react"
import { StoreContext, namespace } from '@/context';
import CommonImage, { ImageType } from "../CommonImage";
// import { ChannelTagDisplayTypeEnum } from "@/api/detail";
import { IThreadLisItem, RankEnum } from "@/api/thread/list";
import CommentSvg from '../../assets/icon/feed/comment.svg';
import { pagePathUrl, getUserHomeUrl } from "@/constants/url";
import UserAction, { USER_ACTION_TYPE } from '@/components/UserAction';
import UserActionCount from '@/components/UserActionCount/mIndex';
import { formatDisplayNumber } from "@/utils/formatNumber";
import useSls, { SlsData } from '@/hooks/useSls';
import { decodeSubjectText } from '@/utils/html';
// import CommentEmojiIcon from '../../assets/icon/feed/commentEmoji.svg';
// import CommentUploadIcon from '../../assets/icon/feed/commentUpload.svg';

// feed流内容卡片组件
const ContentCard: FC<IThreadLisItem> = (props: IThreadLisItem) => {
  const { author, subject, summary, forum_channel_tags: forumChannelTags, covers, tid, praise, praised, favtimes, favorite, views, replies }  = props;
  const defaultAvatar = `${process.env.RESOURCE_URL}uc_server/images/noavatar_middle.gif`;
  const t = useTranslations();
  const { state } = useContext(StoreContext);
  const { account, sensors } = state[namespace.app];
  const { pcActiveChannelName } = state[namespace.home];
  const { track, TRACK_EVENTS } = sensors || {};
  const { reportSlsData } = useSls();

  const onReportSlsData = (data: Array<SlsData>) => {
    reportSlsData(data)
  }

  const handleStopPropagation= (e: React.MouseEvent) => {
    e.stopPropagation(); // 阻止事件冒泡
  };

  const isLoggin = useMemo(() => {
    const { id, uuid, status } = account || {};
    if (status !== PromiseState.PENDING && id && uuid) {
      return true;
    }
    return false;
  }, [account]);

  const handleGotoDetail = (e: any) => {
    e.stopPropagation();
    if (tid) {
      track?.(TRACK_EVENTS?.[namespace.home].threadEntryClick.name, {
        list_name: pcActiveChannelName,
        thread_name: subject,
        thread_tid: tid,
        account_slug: author?.id,
        position: 'Feed',
      }, namespace.home);
      window.open(`${pagePathUrl.detail}?tid=${tid}`);
    }
  };

  const handlerTrackCb = (
    type: USER_ACTION_TYPE,
    isSelected: boolean,
    isSuccess: boolean,
    failReason?: string
  ) => {
    let buttonName = '';
    if (type === USER_ACTION_TYPE.PRAISE) {
      buttonName = isSelected ? 'Unlike' : 'Like';
    } else {
      buttonName = isSelected ? 'Uncollected' : 'Collected';
    }

    const eventName =
      type === USER_ACTION_TYPE.PRAISE
        ? TRACK_EVENTS?.[namespace.home].threadLikeResult.name
        : TRACK_EVENTS?.[namespace.home].threadCollectResult.name;

    track?.(
      eventName,
      {
        list_name: pcActiveChannelName,
        thread_name: subject,
        thread_tid: tid,
        account_slug: author?.id,
        button_name: buttonName,
        is_success: isSuccess,
        fail_reason: failReason,
      },
      namespace.app
    );
  };
  const handleGotoUserPage = (e: React.MouseEvent) => {
    e.stopPropagation();
    track?.(TRACK_EVENTS?.[namespace.home].userProfileEntryClick.name, {
      list_name: pcActiveChannelName,
      thread_name: subject,
      thread_tid: tid,
      account_slug: author?.id,
    }, namespace.home);
    window.open(getUserHomeUrl(author.id, author.uuid));
  }

  return (
    <div className={styles.contentCard}>
      <div className={styles.articalContent} onClick={handleGotoDetail}>
        {/* 头像 */}
        <div className={styles.avatarBox} onClick={handleGotoUserPage}>
          <CommonImage
            className={styles.avatar}
            src={author?.avatar || defaultAvatar}
            layout="fill"
            cutMode='cover'
            type={ImageType.avatar}
          />
        </div>
        <div className={styles.content} onClick={handleGotoDetail} >
          {/* 用户名和身份图标 */}
          <div className={styles.userName} onClick={handleGotoUserPage}>
            {author?.name || ''}
            {author?.rank?.vid && (
               <CommonIcon
                icon={author?.rank?.vid === RankEnum.admin ? 'admin-title' : 'vip-title'}
                className={styles.rankIcon}
              />
              )
            }
          </div>
          {/* 主题 */}
          <h2 className={styles.subject}>{decodeSubjectText(subject)}</h2>
          {/* 摘要 */}
          {summary && (
            <div
              className={styles.summary}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(summary) }}
            />
          )}
          {/* 主内容（图片/视频） */}
          <div className={styles.cardContent}>
            <FeedPreview covers={covers || []} />
          </div>
          {/* 圈子tag  MVP版本暂时隐藏 */}
          {/* <div className={styles.tags}>
            {forumChannelTags.map(item => (
              <div key={item.id} className={styles.tagItem}>
                {(item.display_type === ChannelTagDisplayTypeEnum.ACTIVITY ||
                  item.display_type === ChannelTagDisplayTypeEnum.GROUP) && <CommonIcon className={styles.subjectIcon} icon={item.display_type} />}
                <span className={styles.name}>{item.name}</span>
            </div>
            ))}
          </div> */}
          <div className={styles.actionWrapper}>
            <div className={styles.view}><span>{formatDisplayNumber(views)}</span><>浏览</></div>
            <div className={styles.userAction} onClick={handleStopPropagation}>
              <UserAction
                className={styles.gap}
                tid={tid}
                title={subject || ''}
                type={USER_ACTION_TYPE.PRAISE}
                count={praise || 0}    
                status={praised}
                isLoggin={isLoggin}
                trackCb={handlerTrackCb}
                onReportSlsData={onReportSlsData}
              />
              <UserAction
                className={styles.gap}
                tid={tid}
                title={subject || ''}
                type={USER_ACTION_TYPE.COLLECT}
                count={favtimes || 0}
                status={favorite}
                isLoggin={isLoggin}
                trackCb={handlerTrackCb}
                onReportSlsData={onReportSlsData}
              />
              <div className={styles.comment} onClick={handleGotoDetail}>
                <div className={styles.commentIcon}>
                  <CommentSvg />
                </div>
                <UserActionCount className={styles.commentNum} count={replies} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 评论模块 */}
      {/* <article className={styles.commentWrapper}>
        <section className={styles.commentOperateModule}>
            <div className={styles.commentAvatar}>
              <CommonImage
                layout="fill"
                cutMode='cover'
                type={ImageType.avatar}
                className={styles.commentAvatarCls}
                src={account?.avatar?.medium ?? defaultAvatar}
              />
            </div>
            <div className={styles.commentPublishContainer}>
              <input type="text" placeholder="说说你的想法" className={styles.commentInput} />
              <div className={styles.commentActions}>
                  <div className={styles.uploadAndEmoji}>
                      <div className={styles.icon}><CommentUploadIcon /></div>
                      <div className={styles.icon}><CommentEmojiIcon /></div>
                  </div>
                  <button className={styles.commentButton} type="button">评论</button>
              </div>
            </div>
        </section>
        <div className={styles.splitLine} />
        <section className={styles.commentListContainer}>
            <ul className={styles.commentList}>
              <li className={styles.commentItem}>
                <div className={styles.commentItemAvatar}></div>
                <div className={styles.commentItemContent}>
                    <div className={styles.username}></div>
                    <div className={styles.commentContent}></div>
                </div>
              </li>
            </ul>
        </section>
      </article> */}
    </div>
  )
}

export default ContentCard;
